import { useCallback, useRef, useState } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import Header from './components/Header';
import Banner from './components/Banner';
import PageLoader from './components/PageLoader';
import DestinationSection from './components/DestinationSection';
import StayYourWaySection from './components/StayYourWaySection';
import LocalAreaSection from './components/LocalAreaSection';
import TasteOfJamaicaSection from './components/TasteOfJamaicaSection';
import OurStorySection from './components/OurStorySection';
import StayProcessSection from './components/StayProcessSection';
import GoodToKnowSection from './components/GoodToKnowSection';
import NextChapterCTA from './components/NextChapterCTA';
import Footer from './components/Footer';
import ValdostaProperty from './pages/ValdostaProperty';
import ContactPage from './pages/ContactPage';
import BookingPage from './pages/BookingPage';
import StayPage from './pages/StayPage';
import OurStoryPage from './pages/OurStoryPage';
import ExplorePage from './pages/ExplorePage';
import { stayProperties } from './pages/stayProperties';
import './App.css';

gsap.registerPlugin(useGSAP);

function App() {
  const pathname = window.location.pathname.replace(/\/$/, '') || '/';
  const currentProperty = Object.values(stayProperties).find(property => property.path === pathname);
  const isPropertyPage = Boolean(currentProperty);
  const isStayPage = ['/stay', '/stays'].includes(pathname);
  const isContactPage = /^\/contact\/?$/.test(window.location.pathname);
  const isBookingPage = /^\/booking\/?$/.test(window.location.pathname);
  const isStoryPage = ['/our-story', '/about-us'].includes(pathname);
  const isExplorePage = pathname === '/explore';
  const scope = useRef(null);
  const [ready, setReady] = useState(false);
  const finishLoading = useCallback(() => setReady(true), []);

  useGSAP(() => {
    if (!ready || isPropertyPage || isStayPage || isContactPage || isBookingPage || isStoryPage || isExplorePage) return;
    const media = gsap.matchMedia();
    media.add('(prefers-reduced-motion: no-preference)', () => {
      gsap.timeline({ defaults: { duration: 0.65, ease: 'power3.out', clearProps: 'transform,opacity,visibility' } })
        .from('.site-header__brand', { autoAlpha: 0, y: -15 }, 0)
        .from('.site-header__nav a', { autoAlpha: 0, y: -10, stagger: 0.07 }, 0.08)
        .from('.site-header__cta', { autoAlpha: 0, scale: 0.94 }, 0.2)
        .from('.banner__eyebrow', { autoAlpha: 0, y: 15 }, 0.25)
        .from('.banner h1', { autoAlpha: 0, y: 35 }, 0.35)
        .from('.banner__description', { autoAlpha: 0, y: 20 }, 0.45)
        .from('.banner__actions', { autoAlpha: 0, y: 20 }, 0.55)
        .from('.banner__feature', { autoAlpha: 0, y: 20 }, 0.65)
        .from('.banner__image-reveal', { autoAlpha: 0, scale: 1.06, duration: 1.2 }, 0.25)
        .from('.banner__location', { autoAlpha: 0, y: -12 }, 0.8)
        .from('.banner__note', { autoAlpha: 0, y: 25, scale: 0.96 }, 0.9)
        .from('.booking-bar', { autoAlpha: 0, y: 30 }, 0.8);
    });
    return () => media.revert();
  }, { scope, dependencies: [ready], revertOnUpdate: true });

  if (isPropertyPage) return <ValdostaProperty property={currentProperty} />;
  if (isStayPage) return <StayPage />;
  if (isContactPage) return <ContactPage />;
  if (isBookingPage) return <BookingPage />;
  if (isStoryPage) return <OurStoryPage />;
  if (isExplorePage) return <ExplorePage />;

  return (
    <>
      {!ready && <PageLoader onComplete={finishLoading} />}
      <div ref={scope} className={`site-content${ready ? '' : ' site-content--loading'}`} inert={!ready}>
        <Header />
        <main id="main-content" tabIndex={-1}><Banner /><DestinationSection ready={ready} /><StayYourWaySection ready={ready} /><LocalAreaSection ready={ready} /><TasteOfJamaicaSection /><OurStorySection ready={ready} /><StayProcessSection ready={ready} /><GoodToKnowSection ready={ready} /><NextChapterCTA ready={ready} /></main>
        <Footer ready={ready} />
      </div>
    </>
  );
}
export default App;
